import {Component} from '@angular/core';

@Component({
    template: '<p>PAGE NOT FOUND</p>'
})
export class P404Component {
    constructor() {
    }
}
